<template>
    <div class="contact-details">
        <CompassTooltip :content="labelTooltipAction">
            <CompassLink
                v-if="variant === ENUMS_VARIANT.PHONE"
                :label="$filters.formatPhoneNumber(value, phoneFormat)"
                :link="`${phonecallProtocol}:${value}`"
            />
            <CompassPlainButton v-else :label="value" @click="handleSendEmail" />
        </CompassTooltip>
        <CompassTooltip :content="$t.__('common.actions.copy')">
            <CompassIconButton size="small" icon="duplicate" @click="onCopyToClipboard(value)" />
        </CompassTooltip>
    </div>
</template>
<script>
import EmailMixins from 'mixins/EmailMixins';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapCorpStates } = createNamespacedHelpers('corp');

const ENUMS_VARIANT = Object.freeze({
    PHONE: 'phone',
    EMAIL: 'email',
});

export default {
    mixins: [EmailMixins],
    props: {
        value: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: ENUMS_VARIANT.PHONE,
            validator: (value) => {
                return [ENUMS_VARIANT.PHONE, ENUMS_VARIANT.EMAIL].includes(value);
            },
        },
    },
    data() {
        return { ENUMS_VARIANT };
    },
    computed: {
        ...mapCorpStates(['phoneFormat', 'phonecallProtocol']),
        labelTooltipAction() {
            return this.variant === ENUMS_VARIANT.PHONE
                ? this.$t.__('timeline.TemplateCardAttachment.make_a_call')
                : this.$t.__('common.actions.send_email');
        },
    },
    methods: {
        onCopyToClipboard(value) {
            navigator.clipboard.writeText(value);
            this.$pushToast({
                type: 'success',
                text: this.$t.__('common.label.copy_to_clipboard_success'),
                close: false,
                icon: true,
                unique: true,
            });
        },
        handleSendEmail() {
            this.checkEmailProvider({}, { checkPrefill: true }, this.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.contact-details {
    align-items: center;
    display: flex;
    gap: var(--spacing-1);
}
</style>
